"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports._NoncurrentVersionTransition = {
    type: "structure",
    required: [],
    members: {
        NoncurrentDays: {
            shape: {
                type: "integer"
            }
        },
        StorageClass: {
            shape: {
                type: "string"
            }
        }
    }
};
//# sourceMappingURL=_NoncurrentVersionTransition.js.map